import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Element.Dialog.props.closeOnClickModal.default = false;
Vue.config.productionTip = false;
Vue.use(Element)
